import MoneyInput from 'components/MoneyInput';
import React from 'react';
import { Box } from '@mui/material';
import { formatCents, formatInheritedCents } from 'utils/rateSettings/SharedRateSettingsForm.utils';
import { useResourceContext } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { useRateControllerContext } from '../rateController/RateControllerContext';
import {
  codeToField,
  deriveInheritedRatePreview,
  toBlendedOverride,
} from '../rateController/rateControllerModel';
import { RateFieldCheckbox } from './RateFieldCheckbox';
import { useRecordValueReader } from 'resources/rate_settings/utils/fieldsVisibility';

type Props = { source: string; inheritedSettings?: any };

export const ChargeRateCentsInput = ({ source, inheritedSettings = {} }: Props) => {
  const resource = useResourceContext();
  const { watch } = useFormContext();
  const recordValue = useRecordValueReader();

  const { isControlled } = useRateControllerContext();
  const isLocationLevel =
    resource === 'LocationPositionRateSetting' || resource === 'AgencyLocationPositionRateSetting';
  const label = isLocationLevel ? 'Location Rate' : '8hr Charge Rate';

  // The Location Rate is the applied rate — its preview follows the selected structure.
  const helperText = isLocationLevel
    ? formatCents(
        deriveInheritedRatePreview({
          inherited: inheritedSettings,
          source,
          isLocationLevel,
          useBlendedOverride: toBlendedOverride(watch(`${source}.use_blended_rate`)),
        }).chargeRate,
      )
    : formatInheritedCents(inheritedSettings, 'charge_rate_cents');

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <MoneyInput
        source={codeToField('chargeRate', source, recordValue)}
        label={label}
        disabled={!isControlled('chargeRate')}
        sx={{ flex: 1 }}
        helperText={helperText}
      />
      <RateFieldCheckbox code="chargeRate" label="Admin controls Location Rate" />
    </Box>
  );
};
